import React, { useState, useEffect } from 'react';
import { Box, Checkbox, FormControlLabel, Button, Typography } from '@mui/material';
import axios from 'axios';
import "./Scrollbar.css"
const FacilityFilter = ({ selectedFacilities = [],setErrors, setSelectedFacilities,url,errors }) => {
  const [facilities, setFacilities] = useState([]);

  useEffect(() => {
    // Fetch all Facilities from the backend
    const fetchFacilities = async () => {
      try {
        const response = await axios.get(url);
        // Extract unique Facility names from the user data
        const uniqueFacilities = [...new Set(response.data.data.map((facility) => facility.facilityName))];
        setFacilities(uniqueFacilities);
      } catch (error) {
        console.error('Error fetching Facilities:', error);
      }
    };

    fetchFacilities();
  }, []);

  const handleFacilityChange = (event) => {
    const selectedFacility = event.target.value;
    setErrors((prev) => ({
      ...prev,
      Facility: "", // Clear the error for Date
    }));
    if (event.target.checked) {
      // Add Facility to selected list
      setSelectedFacilities((prevSelected) => [...prevSelected, selectedFacility]);
    } else {
      // Remove Facility from selected list
      setSelectedFacilities((prevSelected) =>
        prevSelected.filter((Facility) => Facility !== selectedFacility)
      );
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column',ml:2,height:"100%" }}>
     <Typography
        variant="h5"
        gutterBottom
        sx={{
          fontWeight: 'bold',
          marginBottom: '30px',
          
         }}
      >
        Facility
      </Typography>
      <Box className="scrollable-container">
      {facilities.length > 0 ? (
        facilities.map((Facility, index) => (
          <FormControlLabel
            key={index}
            control={
              <Checkbox
                value={Facility}
                checked={selectedFacilities?.includes(Facility)} // Ensure selectedFacilities is an array
                onChange={handleFacilityChange}
              />
            }
            label={Facility}
          />
        ))
      ) : (
        <Typography>No Facilities found</Typography>
      )}
    </Box>
    {errors && (
            <Typography variant="body2" color="#D34040" sx={{ mt: 2 }}>
              {errors}
            </Typography>
          )}
    </Box>
  );
};

export default FacilityFilter;

